<template>
  <v-app>
    <v-app-bar
        app
        color="primary"
        dark
    >
      <v-img
          class="ml-0 mr-3"
          src="images/logo-icl.jpg"
          max-height="35"
          max-width="150"
          contain
      ></v-img>
      <v-app-bar-title style="text-overflow: unset;">COVID-19 Orphanhood</v-app-bar-title>
      <v-spacer></v-spacer>
      <span style="color: white; font-style: italic;">Preliminary estimates using excess mortality from The Economist</span>
    </v-app-bar>

    <v-main>
      <router-view class="mt-5"></router-view>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'App',

  components: {
  },

  data: () => ({
    //
  }),
};
</script>

<style lang="scss">
$font-family: 'Fira Sans';

.theme--light.v-application {
  background-color: #e7ecf3 !important;
}

.v-application {
  [class*='text-'] {
    color: #36405a;
    font-family: $font-family, sans-serif !important;
  }

  font-family: $font-family, sans-serif !important;
}

.v-app-bar-title {
  font-weight: 600;
}

</style>
